module.exports = __webpack_public_path__ + "static/img/luse.f954f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/luse.png
// module id = RFk/
// module chunks = 1